import { Injectable } from '@angular/core';
import { FirebaseStorageService } from "app/services/firebase-storage.service";
import { FirebaseService } from "app/services/firebase.service";
import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import * as _ from 'underscore';
import { NotificationsService } from "angular2-notifications";

@Injectable()
export class DocumentService {
    private db;
    private storageRootRef;
    documents: FirebaseListObservable<Document[]>;
    name;
    url;
    size;
    sanitizeName;
    trueName;

    constructor(
        private firebaseService: FirebaseService,
        private firebaseStorageService: FirebaseStorageService,
        private notificationsService: NotificationsService
    ) {
        this.db = firebaseService.db;
        this.storageRootRef = firebaseStorageService.storageRootRef;
        this.loadDocumentDb();
    }

    loadDocumentDb() {
        window.dispatchEvent(new Event('loading'));
        this.documents = this.db.list('/documents') as FirebaseListObservable<Document[]>
        this.documents.subscribe(data => {
            this.triggerDataChange();
        });
    }

    triggerDataChange() {
        window.dispatchEvent(new Event('data-loaded'));
    }

    getDocuments() {
        return this.documents;
    }

    documentUpload(data) {

        var self = this;
        this.sanitizeName = data.selectedFile.name.toLowerCase().match(/\w+/g).join('-');
        var rawName = data.selectedFile.name.replace(/%/g, '');
        console.log('2: ' + this.sanitizeName)
        var check = this.checkDataexistence(this.sanitizeName, rawName);
        var metadata = {
            name: this.trueName,
        }
        var storageChildRef = this.storageRootRef.child('media/documents/' + this.trueName);
        var task = storageChildRef.put(data.selectedFile, metadata);
        task.on('state_changed',
            function progress(snapshot) {
                if (data.progress) {
                    data.progress.style.display = 'block';
                }
                var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if (data.uploader) {
                    data.uploader.style.width = percentage + '%';
                }
            },
            function error(err) {
                console.log('Error bos');
            },
            function complete() {
                if (data.closeBtn) {
                    for (var i in data.closeBtn) {
                        if (data.closeBtn.hasOwnProperty(i)) {
                            data.closeBtn[i].style.display = 'block';
                        }
                    }
                }
                if (data.modalTitle) {
                    data.modalTitle.innerHTML = 'Upload Complete';
                }
                storageChildRef.getMetadata().then(function (metadata) {
                    var document = new Document();
                    document.$key = metadata.name.toLowerCase().match(/\w+/g).join('-');
                    console.log('3: ' + document.$key)
                    document.name = metadata.name;
                    document.url = metadata.downloadURLs;
                    document.size = metadata.size;
                    document.fullpath = metadata.fullPath;
                    document.contentType = metadata.contentType;
                    self.addDocument(document);
                });
                if (data.progress) {
                    data.progress.style.display = 'none';
                }
                self.notificationsService.success('Uploaded', 'File uploaded')
                if (data.file_name_element) {
                    data.file_name_element.innerHTML = '';
                }
            }
        );
    }

    addDocument(document) {
        if (document.$key) {
            var doc_ref = this.db.object('/documents/' + document.$key) as FirebaseObjectObservable<Document>
            delete document.$key;
            return doc_ref.set(document)
        }
        return false;
    }

    checkDataexistence(sanitizeName, rawName) {
        var self = this;
        var doc_ref = this.db.object('/documents/' + sanitizeName)
        doc_ref.$ref.transaction(function (currentData) {
            if (currentData === null) {
                self.trueName = rawName;
            } else {
                self.trueName = self.nameplus(rawName);
                sanitizeName = self.trueName.toLowerCase().match(/\w+/g).join('-');
                self.checkDataexistence(sanitizeName, self.trueName)
                console.log('5: ' + self.trueName)
            }
        });
    }

    nameplus(name) {
        var ext = name.match(/\.\w{0,4}$/) ? name.match(/\.\w{0,4}$/)[0] : '';
        name = name.replace(/\.\w{0,4}$/, '');
        name = name.replace(/\-\d+$/, '') + '-' + (name.match(/\-\d+$/) ? (parseInt(name.match(/\d+$/)[0]) + 1) : 2);
        console.log('1: ' + name)
        console.log('4: ' + ext)
        return name + ext;
    }

    getDocument(name) {
        var storgaeChildRef = this.storageRootRef.child('media/documents');
        return storgaeChildRef;
    }

    deleteDocument(name, key) {
        var self = this;
        var fileRef = this.firebaseStorageService.storageRootRef.child('media/documents/' + name);
        fileRef.delete().then(function () {
            var result = self.documents.remove(key);
            self.notificationsService.error('Deleted', 'File deleted')
            return result;
        }).catch(function (error) {
            console.log('Hayoloh, ada error. Error: ' + error.code_ + '. Message: ' + error.message_);
        });
    }
}

export class Document {
    $key?: string;
    name?: string = '';
    url?: string[];
    size?: string = '';
    fullpath?: string = '';
    contentType?: string = '';

    created_at?: number;
    updated_at?: number;

    constructor() {
        var now = new Date();
        this.created_at = now.getTime();
        this.updated_at = now.getTime();
    }
}


// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/document.service.ts